import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Checkout = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [products, setProducts] = useState([
    { productId: '123', productName: 'Eye Care Kit', finalCost: '₹1000.00', quantity: 1 },
  ]); // Sample product, extendable
  const [totalCost, setTotalCost] = useState('₹1000.00');

  // Load from session storage on mount
  useEffect(() => {
    const savedEmail = sessionStorage.getItem('email');
    const savedUsername = sessionStorage.getItem('username');
    const savedPhone = sessionStorage.getItem('phone');
    if (savedEmail) setEmail(savedEmail);
    if (savedUsername) setUsername(savedUsername);
    if (savedPhone) setPhone(savedPhone);
  }, []);

  // Save to session storage on change
  const handleInputChange = (setter) => (e) => {
    const value = e.target.value;
    setter(value);
    sessionStorage.setItem(e.target.placeholder.toLowerCase(), value);
  };

  // Update total cost based on products
  useEffect(() => {
    const total = products.reduce((sum, product) => {
      const cost = parseFloat(product.finalCost.replace('₹', '').replace(',', ''));
      return sum + (cost * product.quantity);
    }, 0);
    setTotalCost(`₹${total.toFixed(2)}`);
  }, [products]);

  // Send email on "Completing Further Details" click
  const handleCompleteDetails = async () => {
    try {
      // Prepare data for each product
      const orderDetails = products.map(product => ({
        productId: product.productId,
        finalCost: product.finalCost,
        customerName: username,
        customerEmail: email,
        phoneNumber: phone,
      }));

      const response = await axios.post('https://aramemail.outliersunited.com/send-email', {
        ...orderDetails[0], // Send first product for now, adjust backend if needed
        totalCost,
        products: products, // Include all products for detailed email
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        alert('Order confirmed! Email sent successfully.');
      } else {
        alert('Failed to send email: ' + response.data.error);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Error sending email. Check console for details.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Complete Your Order</h2>
      <input
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={handleInputChange(setEmail)}
        className="w-full mb-4 p-2 border border-gray-300 rounded focus:outline-none"
      />
      <input
        type="text"
        placeholder="Enter username"
        value={username}
        onChange={handleInputChange(setUsername)}
        className="w-full mb-4 p-2 border border-gray-300 rounded focus:outline-none"
      />
      <input
        type="text"
        placeholder="Enter phone number"
        value={phone}
        onChange={handleInputChange(setPhone)}
        className="w-full mb-4 p-2 border border-gray-300 rounded focus:outline-none"
      />
      <div className="mb-4">
        <h3 className="text-lg font-semibold">Order Details</h3>
        {products.map((product, index) => (
          <div key={index} className="mb-2 p-2 border border-gray-200 rounded">
            <p><strong>Product:</strong> {product.productName}</p>
            <p><strong>ID:</strong> {product.productId}</p>
            <p><strong>Cost:</strong> {product.finalCost}</p>
            <p><strong>Quantity:</strong> {product.quantity}</p>
          </div>
        ))}
        <p className="mt-2"><strong>Total Cost:</strong> {totalCost}</p>
      </div>
      <button
        onClick={handleCompleteDetails}
        className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
      >
        Completing Further Details
      </button>
    </div>
  );
};

export default Checkout;